baseApp.directive('notification', ['$sce', function($sce) {
    return {
        restrict: 'E',
        templateUrl: '/public/directives/notifications/notification.html',
        link: function($scope) {
            $scope.$watch('notification.message', function() {

                if ($scope.notification) {
                    if($scope.notification.notificationType === 'CLIENT_UPGRADE'){
                        const message =
                            "For more information click " +
                            "<a href=https://support.catonetworks.com/hc/en-us/sections/360000462277 target=_blank>here</a>"
                        $scope.messageHTML = $sce.trustAsHtml(message);
                    }
                    else if ($scope.notification.notificationType === 'SYSTEM_NOTIFICATION') {
                        $scope.messageHTML = $sce.trustAsHtml($scope.notification.message);
                    } else {
                        var encodedContent = $scope.notification.message.replace(/\&/g,"&amp;").replace(/\</g,"&#10094;").replace(/\>/g,"&#10095;")
                            .replace(/\//g,"&#x2F;").replace(/\"/g,"&quot;").replace(/\'/g,"&#x27;");
                        $scope.messageHTML = $sce.trustAsHtml(encodedContent);
                    }
                }
            });
        }
    };
}]);
